import { Card, Grid, List } from '@mui/material';
import ButtonBack from '../Breadcrumb/ButtonBack';
import { ListDenuncia } from './ListDenuncia';

export const Denuncia = () => {
  return (
    <div className='container'>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <ButtonBack marginBottom='1' variant='text' size='small' />
          <Card sx={{ width: '100%', p: 1, paddingX: { xs: 0, sm: 1 } }}>
            <ListDenuncia />
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};
